/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { GetAppInitInitQueryResponse, GetAppInitInit403 } from "../models/GetAppInitInit";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getAppInitInit } from "../axios/getAppInitInit";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getAppInitInitQueryKey = () => ["web-app-bff-api", { url: '/app-init' }] as const

export type GetAppInitInitQueryKey = ReturnType<typeof getAppInitInitQueryKey>

export function getAppInitInitQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getAppInitInitQueryKey()
        return queryOptions<GetAppInitInitQueryResponse, ResponseErrorConfig<GetAppInitInit403>, GetAppInitInitQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return getAppInitInit({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get app init payload (user, client, stations, stations-groups)
 * {@link /app-init}
 */
export function useGetAppInitInit<TData = GetAppInitInitQueryResponse, TQueryData = GetAppInitInitQueryResponse, TQueryKey extends QueryKey = GetAppInitInitQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<GetAppInitInitQueryResponse, ResponseErrorConfig<GetAppInitInit403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getAppInitInitQueryKey()
         

         const query = useQuery({
          ...getAppInitInitQueryOptions(config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetAppInitInit403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}